/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Not_Found_DescriptionInputs */



/**
* | output |
* | --- |
* | "This member does not exist in your organization, or has been removed." |
*
* @param {Member_Not_Found_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_not_found_description = /** @type {((inputs?: Member_Not_Found_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Not_Found_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Mitglied existiert nicht in Ihrer Organisation oder wurde entfernt.")
	return /** @type {LocalizedString} */ ("This member does not exist in your organization, or has been removed.")
});